import { cn } from "@/shared/lib/cn";
import type { HTMLAttributes } from "react";
import { motion, type MotionProps } from "framer-motion";

export type HStackProps = HTMLAttributes<HTMLDivElement> & MotionProps;

export const HStack = ({ className, children, ...props }: HStackProps) => (
	<motion.div className={cn("flex flex-row justify-center items-center", className)} {...props}>
		{children}
	</motion.div>
);
